import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import './App.css';
import LandingPage from './components/LandingPage';
import FeaturesPage from './components/FeaturesPage';
import PricingPage from './components/PricingPage';
import TeamsPage from './components/TeamsPage';
import NavBar from './components/NavBar';
import Footer from './components/Footer';
import IntegrationsPage from './components/IntegrationsPage';
import PrivacyPolicy from './components/PrivacyPolicy';
import BlogPage from './components/BlogPage';
import IntroducingBoxiaTab from './blog/introducing-boxia-tab';
import TopFiveCalendars2025 from './blog/top-5-calendar-apps-2025';
import BestCalendarRemoteTeams2025 from './blog/best-calendar-for-remote-teams-2025';
import BoxiaVsGoogleCalendar2025 from './blog/boxia-vs-google-calendar-2025';
import ChangelogIndex from './components/ChangelogIndex';
import ChangelogEntry from './components/ChangelogEntry';

function App() {
  return (
    <BrowserRouter>
      <div className="flex flex-col min-h-screen">
        <NavBar />
        <main className="flex-grow">
          <Routes>
            <Route path="/" element={<LandingPage />} />
            <Route path="/features" element={<FeaturesPage />} />
            <Route path="/pricing" element={<PricingPage />} />
            <Route path="/teams" element={<TeamsPage />} />
            <Route path="/integrations" element={<IntegrationsPage />} />
            <Route path="/privacy" element={<PrivacyPolicy />} />
            <Route path="/blog" element={<BlogPage />} />
            <Route path="/blog/introducing-boxia-tab" element={<IntroducingBoxiaTab />} />
            <Route path="/blog/top-5-calendar-apps-2025" element={<TopFiveCalendars2025 />} />
            <Route path="/blog/best-calendar-for-remote-teams-2025" element={<BestCalendarRemoteTeams2025 />} />
            <Route path="/blog/boxia-vs-google-calendar-2025" element={<BoxiaVsGoogleCalendar2025 />} />
            <Route path="/changelog" element={<ChangelogIndex />} />
            <Route path="/changelog/:slug" element={<ChangelogEntry />} />
          </Routes>
        </main>
      </div>
    </BrowserRouter>
  );
}

export default App;
